// Hardcoded to point to the migrated Supabase project (yckdzxoniyqwvnlxwsyr).
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://yckdzxoniyqwvnlxwsyr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "sb_publishable_hEkl__iEKV_OOePmbJ0B3g_8pI_bceU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});